import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'
import { Modal } from 'react-bootstrap';
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createTheme } from '@material-ui/core';
import moment from 'moment';
import { setCookie, getCookie } from '../common_component/cookie.js';
import Organization_modal from '../common_component/organization_modal.js';
import Timer_modal from '../common_component/timer_modal.js';
import { Drawer, Button, Space } from 'antd';
// import SetColor from './SetColor.js';
import country_arr from './common_arr/countries-arr.js';
import s_a from './common_arr/states-arr.js';
import Select, { components } from 'react-select';

export const ShowCustomer = () => {

    const [user, setUser] = useState({});
    const [organization_id, setOrganization_id] = useState("")
    const [organization_list, setorganization_list] = useState([]);
    const [timer, setTimer] = useState(0);
    const [clock_timer, setClockTimer] = useState(0);
    const [state, setstate] = useState(2);

    const [responsive, setResponsive] = useState("vertical");
    const [tableBodyHeight, setTableBodyHeight] = useState("400px");
    const [tableBodyMaxHeight, setTableBodyMaxHeight] = useState("");

    const timer_interval_ref = useRef();
    const [clockTimerModalShow, setClockTimerModalShow] = useState(false);
    const [state_org, setstate_org] = useState(2);
    const [organization_name, setOrganization_name] = useState("");
    const [OrganizationModalShow, setOrganizationModalShow] = useState(false);
    const [redirect_to_login, setRedirect_to_login] = useState(2);

    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))

    const [AddGstInmodalShow, setAddGstInmodalShow] = useState(false);
    const [GstInmodalShow, setGstInmodalShow] = useState(false);
    const [LegalName, setLegalName] = useState("");
    const [TradeName, setTradeName] = useState("");
    const [GstIN, setGstIN] = useState("");
    const [GstIN_Id, setGstIN_Id] = useState("");
    const [inputFields, setInputFields] = useState([]);

    const [billingCountryOptions, setBillingCountryOptions] = useState([]);
    const [SupplyStateOptions, setSupplyStateOptions] = useState([]);
    const [placeSupply, setPlaceSupply] = useState(null)

    const [customerList, setCustomerList] = useState([])
    const [gstTreatmentlist, setgstTreatmentlist] = useState([{ label: "Registered Business-Regular", value: "Registered Business-Regular", description: "A business that is registered under GST" }, { label: "Registered Business-Composition", value: "Registered Business-Composition", description: "A business that is registered under composition scheme in GST" }, { label: "Special Economic Zone", value: "Special Economic Zone", description: "Business that is located in a special economic zone" }, { label: "Deeemed Export", value: "Deeemed Export", description: "Supply of goods to an export oriented unit" }, { label: "SEZ Devloper", value: "SEZ Devloper", description: "An organization/person who owns atleast 26% of the equity in creating business units" }])
    const [gstTreatment, setGstTreatment] = useState(null)

    const [navtype, setnavtype] = useState("Overview");
    const [Customer_name, setCustomer_name] = useState("");
    const [Customer_details, setCustomer_details] = useState([]);
    const [Customer_history_details, setCustomer_history_details] = useState([]);
    const [customer_id, setcustomer_id] = useState("");
    const [open, setOpen] = useState(false);
    const [status, setstatus] = useState("");

    const [data, setData] = useState([]);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null)
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)

    const [statusModalShow, setStatusModalShow] = useState(false)
    const [statusId, setStatusId] = useState("")
    const [statusValue, setStatusValue] = useState("")
    const [statusSubmitButtonState, setStatusSubmitButtonState] = useState(false)
    const [customerContactPersons, setCustomerContactPersons] = useState([])
    const [taxDetails, setTaxDetails] = useState([])
    const [visibility, setvisibility] = useState(0);
    const [redirect, setredirect] = useState(0);
    const [read, setread] = useState(2);
    const [write, setwrite] = useState(2);

    var page_name = "customer-list";

    let dropdownStyleDark = {
        option: (provided, state) => ({
            ...provided,
            color: '#dddddf',
            backgroundColor: state.isSelected ? provided.backgroundColor : state.isFocused ? '#5f5f8d' : provided.backgroundColor,
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
            borderColor: "#4c4c71"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
        })
    }

    const onRowClick = (rowData, rowMeta) => {
        // console.log("abc")
        let tempData = customerList.find(option => option.cid == rowData[0])
        setOpen(true);
        setCustomer_name(rowData[1]);
        setcustomer_id(rowData[0]);
        setnavtype("Overview");

        setCustomer_history_details(tempData.customer_history_details);
        setTaxDetails(tempData.tax_details);
        setCustomerContactPersons(JSON.parse(tempData.contact_persons));
        setCustomer_details(tempData);
    }

    const onClose = () => {
        // console.log("abc")
        setOpen(false);
        setCustomer_name("");
        setcustomer_id("");
        setnavtype("Overview");

        setCustomer_history_details([]);
        setTaxDetails([]);
        setCustomerContactPersons([]);
        setCustomer_details({});
    }

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const options = {
        fixedHeader: false,
        selectableRows: "none",
        responsive,
        tableBodyHeight,
        tableBodyMaxHeight,
        onRowClick: onRowClick,
    };

    const columns = [
        {
            name: "cid",
            label: "customer_id",
            options: {
                display: false,
                filter: true,
                sort: true
            }
        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "companyName",
            label: "Company Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "workPhone",
            label: "Work Phone",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "leadSource",
            label: "Lead Source",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let color
                    if (value == "Active")
                        color = "green"
                    else
                        color = "red"

                    return (
                        <p
                            className='my-auto'
                            value={value}
                            onChange={event => updateValue(event.target.value, tableMeta.columnIndex)}
                            style={{ color: color }}>{value}
                        </p>
                    )
                }
            }
        },
        {
            name: "actions",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                download: false
            }
        }
    ];



    const updateStatus = (id) => {
        for (let i = 0; i < customerList.length; i++) {
            if (id == customerList[i].pid) {
                setcustomer_id(id);
                console.log(customerList[i].add_status);
                setstatus(customerList[i].add_status);
            }
        }
    }

    useEffect(() => {
        if (getCookie("access_token") != "") {
            if (getCookie("organization_id") != "") {
                setOrganization_id(getCookie("organization_id"));
            }
            else {
                var object = {};
                object.page_name = page_name;
                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "token": getCookie("access_token"),
                        "Accept": "*/*"
                    }
                }

                axios.post(`${process.env.REACT_APP_SERVER_URL}/show-organization`, object, headers).then((res) => {
                    if (res.data.length == 1) {
                        setCookie('organization_id', res.data[0].organization_id, 1, true);
                        setOrganization_id(res.data[0].organization_id)
                    }
                    else {
                        setstate_org(1);
                        setorganization_list(res.data);
                        setOrganizationModalShow(true);
                    }
                })
            }
        }
        else {
            setRedirect_to_login(1);
        }
    }, [])

    useEffect(() => {
        setCookie("lastpage", window.location.href, 1, false)
        const validateJWT = () => {

            if (getCookie("access_token") != "") {
                var object = {};
                object.token = getCookie("access_token");

                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "*/*"
                    }
                }
                axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var user_object = {};
                        user_object.email = res.data.email;
                        user_object.name = res.data.name;
                        user_object.img = res.data.img;
                        setUser(user_object)
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        setRedirect_to_login(1);
                    });

                object.organization_id = organization_id;
                axios.post(`${process.env.REACT_APP_SERVER_URL}/audience-info`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var token = res.data.audience_license;
                        if (res.data.organization_flag == 0) {
                            setstate_org(3);
                            setOrganization_name(res.data.organization_name);
                            setOrganizationModalShow(true);
                        }
                        else {
                            var path = window.location.pathname;
                            path = path.replace(/\/$/, "");
                            path = decodeURIComponent(path);
                            var original_url = path.split("/")[1]
                            let index = 0;
                            let temp = -1;
                            for (let i = 0; i < res.data.user_access.access.length; i++) {
                                if (temp == 1) break;
                                let component = res.data.user_access.access[i].inside_components;
                                for (let j = 0; j < component.length; j++) {
                                    if (temp == 1) break;
                                    if (component[j].hasOwnProperty(original_url)) {
                                        index = i;
                                        if (component[j][original_url] == 1 && res.data.user_access.access[index].visibility == 1) {
                                            temp = 1;
                                            setvisibility(1);
                                            setread(component[j]["read"])
                                            setwrite(component[j]["write"])
                                            // setwrite(0)
                                            // break;
                                        }
                                        else {
                                            setredirect(1);
                                        }
                                    }
                                    else if (component[j].hasOwnProperty("key")) {
                                        let sub_inside_components = component[j].inside_components
                                        for (let k = 0; k < sub_inside_components.length; k++) {
                                            if (sub_inside_components[k].hasOwnProperty(original_url)) {
                                                index = i
                                                if (sub_inside_components[k][original_url] == 1 && res.data.user_access.access[index].visibility == 1 && component[j].visibility == 1) {
                                                    temp = 1;
                                                    setvisibility(1);
                                                    setread(sub_inside_components[k]["read"])
                                                    setwrite(sub_inside_components[k]["write"])
                                                    // setwrite(0)
                                                    break;

                                                }
                                                else {
                                                    setredirect(1);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        temp = 2;
                                    }
                                }
                            }

                            if (temp == 2) {
                                setredirect(1);
                            }

                        }
                        if (!token.includes("ufhdsupw29fher") || !token.includes("pdbwu27dh6schs") || !token.includes("0dh27agiqbcrwi")) {
                            setCookie('access_token', res.data.audience_license, 1, true)
                            setTimer(process.env.REACT_APP_JWT_EXPIRY);
                        }
                        else {
                            setTimer(res.data.audience_count)
                        }
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                        setRedirect_to_login(1);
                    });
            }
            else {
                setRedirect_to_login(1);
            }
        }
        organization_id != "" && validateJWT();
    }, [organization_id])

    useEffect(() => {
        timer_interval_ref.current = setInterval(() => {
            setTimer((timer) => {
                if (timer > 0 && timer < process.env.REACT_APP_JWT_EXPIRY_NOTICE) {
                    if (!clockTimerModalShow) {
                        setClockTimer(process.env.REACT_APP_JWT_EXPIRY_NOTICE)
                        setClockTimerModalShow(true)
                    }
                }

                // console.log(timer)
                return timer - 1
            })
        }, 1000);

        return () => { clearInterval(timer_interval_ref) };
    }, []);

    async function getCustomers(cp, rpp, sort_c, sort_v, search_v) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/customer-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        let body = await response.json();
        if (body.operation === "success") {
            setCustomerList(body.data.list);
        }
        else {
            throw "no data"
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getCustomers(currentPage, rowsPerPage, sortColumn, sortValue, searchValue)
            p1.then(() => {
                setstate(1)
                console.log("all apis done")
            })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (customerList.length > 0) {
            let temp_data = [];
            customerList.map((obj) => {

                let id = obj.cid;
                let temp_obj = {};
                temp_obj.cid = obj.cid;
                temp_obj.name = obj.customer_display_name;
                temp_obj.companyName = obj.company_name;
                temp_obj.email = obj.email;
                temp_obj.workPhone = obj.work_phone;
                temp_obj.leadSource = obj.lead_source;
                temp_obj.portalAccess = obj.portal_access.toUpperCase();
                // temp_obj.receivables = obj. ;
                temp_obj.status = obj.add_status;

                temp_obj.actions =
                    <div className="dropdown">
                        <button onClick={(e) => { e.stopPropagation() }} className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                        {
                            write ?
                                <>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li className="py-1"><Link className="dropdown-item" to={`/edit-customer-details/${id}`}>Edit Details</Link></li>
                                        {/* <li className="py-1"><Link className="dropdown-item" to={`/customer-point-issue/${id}`}>Customer Point Issue</Link></li> */}
                                        <li className="py-1"><Link onClick={(e) => { e.stopPropagation(); setInputFields(obj.tax_details); setcustomer_id(obj.cid); setGstInmodalShow(true); }} className="dropdown-item">GSTIN Details</Link></li>
                                        <li className="py-1"><Link to={`/customer-address-details/${id}`} className="dropdown-item">Update Addresses</Link></li>
                                        <li><a className="dropdown-item" onClick={(e) => { e.stopPropagation(); setStatusId(id); setStatusValue(obj.add_status); setStatusModalShow(true); }}>Change Status</a></li>
                                    </ul>
                                </>
                                :
                                read &&
                                <>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a className="dropdown-item" href={`/view-customer-details/${id}`}>View Details</a></li>
                                    </ul>
                                </>
                        }

                    </div>

                temp_data.push(temp_obj);
            })
            setData(temp_data);
        }
        else {
            setData([]);
        }
    }, [customerList])

    useEffect(() => {
        let obj_array = []
        country_arr.country_arr.forEach((obj, index) => {
            if (index != 0) {
                let obj2 = {};
                obj2.label = obj;
                obj2.value = obj;

                obj_array.push(obj2);
            }
        })
        setBillingCountryOptions(obj_array);
    }, []);

    useEffect(() => {
        if (billingCountryOptions.length > 0) {
            let selectedCountryIndex = 0;
            billingCountryOptions.map((obj, index) => {
                // console.log(obj.value);
                if (obj.value == "India") {
                    selectedCountryIndex = index;
                }
            })
            // console.log(selectedCountryIndex)

            let state_arr = s_a.s_a[selectedCountryIndex + 1].split("|");
            let obj_array = [];
            for (let i = 0; i < state_arr.length; i++) {
                obj_array.push({ value: state_arr[i], label: state_arr[i] });
            }
            setSupplyStateOptions(obj_array);
        }

    }, [billingCountryOptions]);

    const handleEditModalShow = (obj) => {
        setGstIN_Id(obj.unique_id);
        setGstIN(obj.GstIn);
        setPlaceSupply({ label: obj.place_of_supply, value: obj.place_of_supply });
        setLegalName(obj.legal_name);
        setTradeName(obj.trade_name);
        setGstTreatment({ label: obj.gst_treatment, value: obj.gst_treatment });
        setGstInmodalShow(false);
        setAddGstInmodalShow(true);
    }

    const handleAddModalShow = () => {
        setGstIN("");
        setPlaceSupply("");
        setLegalName("");
        setTradeName("");
        setGstTreatment("");
        setGstInmodalShow(false);
        setAddGstInmodalShow(true)
    }

    const newGstInSubmit = () => {

        var object = {};

        if (GstIN === null) {
            swal("Warning!", "GSTIN cannot be empty", "warning");
            return
        }
        if (LegalName === null) {
            swal("Warning!", "Business Legal Name cannot be empty", "warning");
            return
        }
        if (placeSupply === null) {
            swal("Warning!", "Supply place cannot be empty", "warning");
            return
        }

        object.GstIn = GstIN;
        object.customer_id = customer_id;
        object.gstTreatment = gstTreatment.value;
        object.place_of_supply = placeSupply.value;
        object.legal_name = LegalName;
        object.trade_name = TradeName;
        object.id = GstIN_Id;

        object.organization_id = organization_id;
        object.page_name = page_name;


        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/save-customer-tax-details`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Tax details added successfully!", "success");
                setAddGstInmodalShow(false);
                getCustomers(currentPage, rowsPerPage, sortColumn, sortValue, searchValue);
                //handleNewTermsModalClose()
                //getTerms()
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const submitStatus = () => {
        let values = { "id": statusId, "status": (statusValue == "Active") ? "Deactivated" : "Active", "page_name": page_name, "organization_id": organization_id };

        console.log(values);
        setStatusSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-status-customer`, values, headers).then((res) => {
            setStatusSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Status changed successfully!", "success")
                handleStatusModalClose()
                getCustomers()
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const handleStatusModalClose = () => {
        setStatusModalShow(false)
        setStatusId("")
        setStatusValue("")
    }

    useEffect(() => {
        let id = setInterval(() => {
            setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
        }, 10)

        return () => {
            clearInterval(id)
        }
    }, [])

    return (
        <>
            {
                (redirect == 1 || (read == 0 && write == 0)) ?
                    <>
                        <Redirect to={{
                            pathname: "/unauthorized",
                        }}
                        />
                    </> :
                    null
            }
            {
                redirect_to_login == 0 ? null : (redirect_to_login == 1 ? <>
                    <Redirect to={{ pathname: "/login" }} />
                </> : null)
            }

            <div className="d-flex flex-column flex-column-fluid">
                <div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Show Customers</h1>
                    </div>
                </div>
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    <div id="kt_app_content_container" className="app-container container-xxl">

                        <div className="card">
                            <div className="card-body pt-6">
                                {
                                    state == 1 ?
                                        <>
                                            <MuiThemeProvider theme={createTheme({ palette: { type: userTheme } })}>
                                                <MUIDataTable
                                                    title={"Customer Details"}
                                                    data={data}
                                                    columns={columns}
                                                    options={options}
                                                />
                                            </MuiThemeProvider>
                                        </>
                                        :
                                        state == 2 ?
                                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                            :
                                            <>
                                                <div className="card-body pt-0">
                                                    <div className="text-gray-500 fw-bold fs-5 mb-5">Show Customers</div>

                                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                        <div className="d-flex flex-stack flex-grow-1">
                                                            <div className="fw-bold">
                                                                <h4 className="text-gray-800 fw-bolder">No Customers Added.</h4>
                                                                <div className="fs-6 text-gray-600"> </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Modal show={GstInmodalShow} onHide={() => { setGstInmodalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>GSTIN Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGstInmodalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ "background-color": "#f4f6f9" }}>
                    <div className='container'>
                        {
                            inputFields.length === 0 ?
                                <div className="overflow-auto pb-5">
                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
                                        <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5687 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5687 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="currentColor"></path>
                                                <path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                        <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                            <div className="mb-3 mb-md-0 fw-semibold">
                                                <h4 className="text-gray-900 fw-bold">No Data Available.</h4>
                                                <div className="fs-6 text-gray-700 pe-7">Login into Admin Dashboard to make sure the data integrity is OK</div>
                                            </div>
                                            {/*<a href="#" className="btn btn-primary px-6 align-self-center text-nowrap">Proceed</a>*/}
                                        </div>
                                    </div>
                                </div>
                                :
                                <>
                                    <div className="d-flex flex-wrap gap-5">

                                        {inputFields.map((obj, index) => {
                                            return (
                                                <>
                                                    <div className="fv-row w-100 flex-md-root">
                                                        <div className="card card-flush h-lg-100">
                                                            <div className="card-header mt-6">
                                                                <div className="card-title flex-column">
                                                                    <h3 className="fw-bolder mb-1">{obj.GstIn}</h3>
                                                                    {/*obj.add_status == "Active" ? <span className="badge badge-light-success me-auto rounded">Active</span> : (obj.add_status == "Stopped" ? <span className="badge badge-light-danger me-auto rounded">Stopped</span> : <span className="badge badge-light-danger me-auto rounded">Deactivated</span>)*/}
                                                                </div>
                                                                <div className="card-toolbar">
                                                                    <div className="dropdown">
                                                                        {
                                                                            (write) ?
                                                                                <>
                                                                                    <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                        {/* <Link><span to={`update-vendor/${id}`} className="dropdown-item">Edit Details</span></Link> */}
                                                                                        <button onClick={(e) => { handleEditModalShow(obj) }} className="dropdown-item">Edit Details</button>

                                                                                        {/* <li><span onClick={(e) => { changeVendorStatus(id, (obj.add_status == "Active" ? "Deactive" : "Active")); }} className={`dropdown-item ${obj.add_status == "Active" ? "text-danger" : "text-success"}`}>{obj.add_status == "Active" ? "Deactivate" : "Activate"}</span></li> */}
                                                                                    </ul>
                                                                                </>
                                                                                :
                                                                                null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-wrap">
                                                                <div className="card-body p-9">
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                        <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                        <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                                                        <div className="fw-semibold text-gray-400">Place of Supply</div>
                                                                    </div>
                                                                    {/*<div className="separator separator-dashed"></div>
                                        <div className="fs-6 d-flex justify-content-between my-4">
                                            <div className="fw-bold">GST treatment</div>
                                            <div className="d-flex text-gray-700 fw-semibold fs-6">
                                            {obj.gst_treatment}</div>
                                        </div>
                                        <div className="separator separator-dashed"></div>
                                        <div className="fs-6 d-flex justify-content-between mt-4">
                                            <div className="fw-bold">Place of Supply</div>
                                            
                                            <div className="d-flex text-gray-700 fw-semibold fs-6">{obj.place_of_supply}</div>
                                        </div><br />
                                        <div className="separator separator-dashed"></div>
                                        <div className="fs-6 d-flex justify-content-between mt-4">
                                            <div className="fw-bold">City</div>
                                            <div className="d-flex text-gray-700 fw-semibold fs-6">{obj.city},{obj.pincode}</div>
                                        </div>*/}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/*<div className="card-body d-flex flex-center flex-column py-9 px-5">
                                    <div className="symbol symbol-65px symbol-circle mb-5">
                                        <span className="symbol-label fs-2x fw-semibold text-warning bg-light-warning">A</span>
                                        <div className="bg-success position-absolute rounded-circle translate-middle start-100 top-100 border border-4 border-body h-15px w-15px ms-n3 mt-n3"></div>
                                    </div>*
                                    <a href="#" className="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{obj.GstIn}</a>
                                    <div className="fw-semibold text-gray-400 mb-6">{obj.legal_name}</div>
                                    <div className="d-flex flex-center flex-wrap mb-5">
                                        <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                            <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                            <div className="fw-semibold text-gray-400">GST treatment</div>
                                        </div>
                                        <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                            <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                            <div className="fw-semibold text-gray-400">Place of Supply</div>
                                        </div>
                                    </div>
                                    <button className="btn btn-sm btn-light-primary" data-kt-follow-btn="true" onClick={() => { handleEditModalShow(obj) }}>
                                        <span className="svg-icon following svg-icon-3">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"></path>
                                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                        <span className="svg-icon follow svg-icon-3 d-none">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1" transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                                <rect x="4.36396" y="11.364" width="16" height="2" rx="1" fill="currentColor"></rect>
                                            </svg>
                                        </span>
                                        <span className="indicator-label">Edit</span>
                                        <span className="indicator-progress">Please wait... 
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                                    </button>
                                </div>*/}
                                                    </div>
                                                </>

                                            )
                                        })
                                        }
                                    </div>
                                </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <button className='btn btn-success' onClick={(e) => { handleAddModalShow(); }}><i className="las la-plus"></i>
                        Add New
                    </button>
                    <button className="btn btn-danger rounded" onClick={() => { setGstInmodalShow(false) }}>Close</button>
                    {/*
                        // write == 1 &&
                        <button className="btn btn-success rounded" data-kt-indicator={submitButton ? "on" : "off"} disabled={submitButton} onClick={() => { newDealerAddressSubmit() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    */}
                </Modal.Footer>
            </Modal>

            <Modal show={AddGstInmodalShow} onHide={() => { setAddGstInmodalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Add GSTIN Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAddGstInmodalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex flex-wrap gap-5 mb-2">
                            <div className="fv-row w-100 flex-md-root">
                                <label className="form-label">GST Treatment</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={gstTreatmentlist}
                                    value={gstTreatment}
                                    onChange={(val) => { setGstTreatment(val) }}
                                    components={{
                                        Option: (props) => {
                                            console.log(props);
                                            return (
                                                <components.Option  {...props}>
                                                    {props.children}
                                                    <span className="fw-semibold text-gray-400 d-block fs-8">{props.data.description}</span>
                                                </components.Option >
                                            )
                                        }
                                    }}
                                />
                            </div>

                        </div>
                        <div className="d-flex flex-wrap gap-5">

                            <div className="fv-row w-100 flex-md-root">
                                <label className="required form-label">GSTIN</label>
                                <input id="GSTIN" type="text" className="form-control mb-2" placeholder="" name="GSTIN" value={GstIN} onChange={(e) => { setGstIN(e.target.value) }} />
                            </div>
                            <div className="fv-row w-100 flex-md-root">
                                <label className="required form-label">Business Legal Name</label>
                                <input id="Business_Legal_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Legal_Name" value={LegalName} onChange={(e) => { setLegalName(e.target.value) }} />
                            </div>

                        </div>
                        <div className="d-flex flex-wrap gap-5">
                            <div className="fv-row w-100 flex-md-root">
                                <label className="required form-label">Place Of Supply</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={SupplyStateOptions}
                                    onChange={(val) => { setPlaceSupply(val) }}
                                    value={placeSupply}
                                    isClearable
                                />
                            </div>
                            <div className="fv-row w-100 flex-md-root">
                                <label className="form-label">Business Trade Name</label>
                                <input id="Business_Trade_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Trade_Name" value={TradeName} onChange={(e) => { setTradeName(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setAddGstInmodalShow(false) }}>Close</button>
                    {
                        write == 1 &&
                        <button className="btn btn-info rounded" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={() => { newGstInSubmit() }}>
                            <span className="indicator-label">Save</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={statusModalShow} onHide={() => { handleStatusModalClose() }} >
                <Modal.Header>
                    <Modal.Title>Change Status</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleStatusModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="form-group row">
                            <div className="col-lg-12">
                                Current Status is : {statusValue == "Active" ? <span className="fs-5 fw-bolder text-success"> Active </span> : <span className="fs-5 fw-bolder text-danger"> Deactivated </span>}
                                <h3>Are you sure about changing status?</h3>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary rounded" onClick={() => { handleStatusModalClose() }}>Cancel</button>
                    {
                        (statusValue == "Active") ?
                            <button type="button" className="btn btn-danger rounded" data-kt-indicator={statusSubmitButtonState ? "on" : "off"} disabled={statusSubmitButtonState} onClick={(e) => { submitStatus() }} >
                                <span className="indicator-label">Deactivate</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                            :
                            <button type="button" className="btn btn-success rounded" data-kt-indicator={statusSubmitButtonState ? "on" : "off"} disabled={statusSubmitButtonState} onClick={(e) => { submitStatus() }} >
                                <span className="indicator-label">Activate</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                    }
                </Modal.Footer>
            </Modal>
            <Drawer title={Customer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open}
                extra={
                    <Space>
                        {/* <div className="dropdown">
                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fas fa-bars px-0"></i>
                            </button>
                            {write &&
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><Link className="dropdown-item" to={`/edit-customer-details/${customer_id}`}>Edit Details</Link></li>
                                    <Link onClick={(e) => { setInputFields(Customer_details); setGstInmodalShow(true); }} className="dropdown-item">GSTIN Details</Link>
                                    <Link to={`/customer-address-details/${customer_id}`} className="dropdown-item">Update Addresses</Link>
                                    <li><a className="dropdown-item" onClick={(e) => { setStatusId(customer_id); setStatusValue(Customer_details[0].add_status); setStatusModalShow(true); }}>Change Status</a></li>
                                </ul>
                            }
                        </div> */}
                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Transaction</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "GST" && "active"}`} onClick={(e) => { setnavtype("GST"); }}>GST Details</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Contact" && "active"}`} onClick={(e) => { setnavtype("Contact"); }}>Contact</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card" id="kt_profile_details_view">
                    {navtype === "Overview" ?
                        <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                    <h3 className="fw-bold m-0">Overview</h3>
                                </div>
                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                            </div>
                            {Customer_details != undefined &&
                                <div className="card-body p-9">
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Customer Type</label>
                                        <div className="col-lg-8">
                                            <span className="fw-bold fs-6 text-gray-800">{Customer_details.customer_type}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Company Name</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Customer_details.company_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Status
                                        </label>
                                        <div className="col-lg-8 d-flex align-items-center">
                                            {Customer_details.add_status === "Active" ?
                                                <span className="badge badge-success">{Customer_details.add_status}</span>
                                                :
                                                <span className="badge badge-danger">{Customer_details.add_status}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Mobile</label>
                                        <div className="col-lg-8">
                                            <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Customer_details.mobile}</a>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Work Phone</label>
                                        <div className="col-lg-8">
                                            <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Customer_details.work_phone}</a>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Email</label>
                                        <div className="col-lg-8">
                                            <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Customer_details.email}</a>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Website</label>
                                        <div className="col-lg-8">
                                            <span className="fw-semibold fs-6 text-gray-800">{Customer_details.website}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Designation
                                        </label>
                                        <div className="col-lg-8">
                                            <span className="fw-bold fs-6 text-gray-800">{Customer_details.designation}</span>
                                        </div>
                                    </div>
                                    {
                                        <>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Currency</label>
                                                <div className="col-lg-8">
                                                    {/* <span className="fw-bold fs-6 text-gray-800">{JSON.parse(Customer_details.currency).currency_code}</span> */}
                                                </div>
                                            </div>
                                            <div className="row mb-10">
                                                <label className="col-lg-4 fw-semibold text-muted">Lead Source</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-semibold fs-6 text-gray-800">{Customer_details.lead_source}</span>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">state</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-semibold fs-6 text-gray-800">{Customer_details.state}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Country</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-semibold fs-6 text-gray-800">{Customer_details.country}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Remarks</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-semibold fs-6 text-gray-800">{Customer_details.remarks}</span>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            }
                        </>
                        :
                        navtype === "Batch_Serial" ?
                            <>
                                <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                    <div className="card-title m-0">
                                        <h3 className="fw-bold">{Customer_details.tracking_inventory_type === "Track Serial Number" ? <>Serial</> : <>Batch</>} Details</h3>
                                    </div>
                                    {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                </div>
                            </>
                            :
                            navtype === "Transactions" ?
                                <>
                                    <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                        <div className="card-title m-0">
                                            <h3 className="fw-bold m-0">Transaction Details</h3>
                                        </div>
                                        {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                    </div>
                                    {Customer_details.length > 0 &&
                                        <div className="card-body p-9">

                                        </div>
                                    }
                                </>
                                :

                                navtype === "GST" ?
                                    <>
                                        <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                            <div className="card-title m-0">
                                                <h3 className="fw-bold m-0">GST Details</h3>
                                            </div>
                                            {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                        </div>
                                        {Customer_details != undefined &&
                                            <div className="card-body p-9">
                                                {taxDetails.map((obj, index) => {
                                                    return (
                                                        <>
                                                            <div className="fv-row w-100 flex-md-root">
                                                                <div className="card card-flush h-lg-100">
                                                                    <div className="card-header mt-2">
                                                                        <div className="card-title flex-column">
                                                                            <h5 className="fw-bolder mb-1">{obj.GstIn}</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex flex-wrap">
                                                                        <div className="card-body p-3">
                                                                            <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                                <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                                <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                            </div>
                                                                            <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                                <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                                <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                                            </div>
                                                                            <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                                <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                                                                <div className="fw-semibold text-gray-400">Place of Supply</div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </div>
                                        }
                                    </>
                                    : navtype === "Contact" ?
                                        <>
                                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                                <div className="card-title m-0">
                                                    <h3 className="fw-bold m-0">Contact</h3>
                                                </div>
                                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                            </div>
                                            {Customer_details != undefined &&
                                                <div className="card-body p-9">
                                                    <div className='container' style={{ minWidth: "max-content" }}>
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" className="col">
                                                                        <label className="fs-5 fw-bold mb-2">Name</label>
                                                                    </th>
                                                                    <th scope="col" className="col">
                                                                        <label className="fs-5 fw-bold mb-2">Email Address</label>
                                                                    </th>
                                                                    <th scope="col" className="col">
                                                                        <label className="fs-5 fw-bold mb-2">Work Phone</label>
                                                                    </th>
                                                                    <th scope="col" className="col">
                                                                        <label className="fs-5 fw-bold mb-2">Mobile</label>
                                                                    </th>
                                                                    <th scope="col" className="col">
                                                                        <label className="fs-5 fw-bold mb-2">Designation</label>
                                                                    </th>
                                                                    <th scope="col" className="col">
                                                                        <label className="fs-5 fw-bold mb-2">Department</label>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    customerContactPersons.map((obj, indx) => {
                                                                        return (
                                                                            <tr >
                                                                                <td scope="col my-auto px-0 py-1">
                                                                                    {obj.salutation + " " + obj.firstName + " " + obj.lastName}
                                                                                </td>
                                                                                <td scope="col my-auto px-0 py-1">
                                                                                    {obj.email}
                                                                                </td>
                                                                                <td scope="col my-auto px-0 py-1">
                                                                                    {obj.workPhone}
                                                                                </td>
                                                                                <td scope="col my-auto px-0 py-1">
                                                                                    {obj.mobile}
                                                                                </td>
                                                                                <td scope="col my-auto px-0 py-1">
                                                                                    {obj.designation}
                                                                                </td>
                                                                                <td scope="col my-auto px-0 py-1">
                                                                                    {obj.department}
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                        :
                                        navtype === "History" &&
                                        <>
                                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                                <div className="card-title m-0">
                                                    <h3 className="fw-bold m-0">History</h3>
                                                </div>
                                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                            </div>
                                            {Customer_details != undefined &&
                                                <div className="card-body p-9">
                                                    {Customer_history_details.map((obj, index) => {
                                                        return (
                                                            <>
                                                            <div className="m-0">
                                                                <div className="d-flex align-items-sm-center mb-5">
                                                                    {/* <div className="timeline-icon symbol symbol-circle symbol-40px">
                                                                        <div className="symbol-label bg-light">
                                                                            <span className="svg-icon svg-icon-2 svg-icon-gray-500"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="currentColor"></path>
                                                                            <path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="currentColor"></path>
                                                                            </svg>
                                                                            </span>
                                                                        </div>
                                                                    </div> */}
                                                                    <div className="d-flex align-items-center flex-row-fluid flex-wrap">                    
                                                                        <div className="flex-grow-1 me-2">
                                                                        {obj.operation === "add" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span>:<span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                                            {/* <span className="text-gray-800 fw-bold d-block fs-4">{obj.operation === "voucher_creation" &&<>#<a href="#" className="text-primary fw-bold me-1">#{OBJ.MASTER_VOUCHER_NAME}</a></>}</span> */}
                                                                        </div>                     
                                                                        
                                                                        {/* <span className="badge badge-lg badge-light-success fw-bold my-2">Delivered</span> */}
                                                                    </div>               
                                                                </div>
                                                                <div className="timeline">                                 
                                                                    <div className="timeline-item align-items-center mb-7">
                                                                        <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                            <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                            <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                            </svg>
                                                                        </span>
                                                                        <div className="timeline-content m-0">
                                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                            <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>   
                                                                        </div>                                 
                                                                    </div>
                                                                    <div className="timeline-item align-items-center">
                                                                        <div className="timeline-line w-40px"></div>
                                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                            <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                            <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                            </svg>
                                                                        </span>
                                                                        <div className="timeline-content m-0">
                                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                            <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                                        </div>                                
                                                                    </div>                                        
                                                                </div>
                                                            </div>
                                                            {Customer_history_details.length>1 &&
                                                                <div className="separator separator-dashed my-6"></div>
                                                            }
                                                                {/* <div className="timeline">
                                                                    {index % 2 === 0 ?
                                                                        <div className="timeline-item">
                                                                            <div className="timeline-line w-40px"></div>
                                                                            <div className="timeline-icon symbol symbol-circle symbol-40px">
                                                                                <div className="symbol-label bg-light">
                                                                                    <span className="svg-icon svg-icon-2 svg-icon-gray-500">
                                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path opacity="0.3" d="M5.78001 21.115L3.28001 21.949C3.10897 22.0059 2.92548 22.0141 2.75004 21.9727C2.57461 21.9312 2.41416 21.8418 2.28669 21.7144C2.15923 21.5869 2.06975 21.4264 2.0283 21.251C1.98685 21.0755 1.99507 20.892 2.05201 20.7209L2.886 18.2209L7.22801 13.879L10.128 16.774L5.78001 21.115Z" fill="currentColor"></path>
                                                                                            <path d="M21.7 8.08899L15.911 2.30005C15.8161 2.2049 15.7033 2.12939 15.5792 2.07788C15.455 2.02637 15.3219 1.99988 15.1875 1.99988C15.0531 1.99988 14.92 2.02637 14.7958 2.07788C14.6717 2.12939 14.5589 2.2049 14.464 2.30005L13.74 3.02295C13.548 3.21498 13.4402 3.4754 13.4402 3.74695C13.4402 4.01849 13.548 4.27892 13.74 4.47095L14.464 5.19397L11.303 8.35498C10.1615 7.80702 8.87825 7.62639 7.62985 7.83789C6.38145 8.04939 5.2293 8.64265 4.332 9.53601C4.14026 9.72817 4.03256 9.98855 4.03256 10.26C4.03256 10.5315 4.14026 10.7918 4.332 10.984L13.016 19.667C13.208 19.859 13.4684 19.9668 13.74 19.9668C14.0115 19.9668 14.272 19.859 14.464 19.667C15.3575 18.77 15.9509 17.618 16.1624 16.3698C16.374 15.1215 16.1932 13.8383 15.645 12.697L18.806 9.53601L19.529 10.26C19.721 10.452 19.9814 10.5598 20.253 10.5598C20.5245 10.5598 20.785 10.452 20.977 10.26L21.7 9.53601C21.7952 9.44108 21.8706 9.32825 21.9221 9.2041C21.9737 9.07995 22.0002 8.94691 22.0002 8.8125C22.0002 8.67809 21.9737 8.54505 21.9221 8.4209C21.8706 8.29675 21.7952 8.18392 21.7 8.08899Z" fill="currentColor"></path>
                                                                                        </svg>
                                                                                    </span>

                                                                                </div>
                                                                            </div>
                                                                            <div className="timeline-content mb-10 mt-n2">
                                                                                <div className="overflow-auto pe-3">
                                                                                    <div className="fs-5 fw-semibold mb-2">{Customer_name} {obj.operation === "add" || obj.operation === "insert" ? <>created</> : <>updated</>}</div>
                                                                                    <div className="d-flex align-items-center mt-1 fs-6">
                                                                                        <div className="text-muted me-2 fs-7">{obj.operation === "add" || obj.operation === "insert" ? <>created</> : <>updated</>} at {moment(obj.log_date_time).format("lll")} by {obj.user_id}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        <div className="timeline-item">
                                                                            <div className="timeline-line w-40px"></div>
                                                                            <div className="timeline-icon symbol symbol-circle symbol-40px">
                                                                                <div className="symbol-label bg-light">
                                                                                    <span className="svg-icon svg-icon-2 svg-icon-gray-500">
                                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="currentColor"></path>
                                                                                            <path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="currentColor"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="timeline-content mb-10 mt-n1">
                                                                                <div className="pe-3 mb-5">
                                                                                    <div className="fs-5 fw-semibold mb-2">{Customer_name} {obj.operation === "add" || obj.operation === "insert" ? <>created</> : <>updated</>}</div>
                                                                                    <div className="d-flex align-items-center mt-1 fs-6">
                                                                                        <div className="text-muted me-2 fs-7">{obj.operation === "add" || obj.operation === "insert" ? <>created</> : <>updated</>} at {moment(obj.log_date_time).format("lll")} by {obj.user_id}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div> */}
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            }
                                        </>
                    }
                </div>
                {/*<Drawer
            title={tag_name}
            width={window.innerWidth > 1200 ? 440 : 'auto'}
            closable={true}
            onClose={onChildrenDrawerClose}
            open={childrenDrawer}
            >

            </Drawer>*/}
            </Drawer>

            <Organization_modal OrganizationModalShow={OrganizationModalShow} setOrganizationModalShow1={setOrganizationModalShow} organization_name={organization_name} organization_list={organization_list} organization_id={organization_id} state_org={state_org} />
            <Timer_modal clockTimerModalShow={clockTimerModalShow} setClockTimerModalShow1={setClockTimerModalShow} clock_timer={clock_timer} organization_id={organization_id} setTimer={setTimer} />
        </>
    );
};
export default ShowCustomer;